import defaultLang from './lang/zh-CN';
export const t = function (key) {
    let globalLang = (window.GLOBAL_LANG_HIUI || {});
    let lang = Object.assign({}, defaultLang, globalLang);
    return lang[key] || key;
};